<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Company
        b-col(md="4")
          b-form-group(:label="$t('label.company')", :label-for="$t('label.company')", description="")
            validation-provider(:name="$t('label.company')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="company",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}

      // Economic Crimes Law Investigators
      b-row.mt-2
        b-col(md="12")
          h5 {{ $t('label.economicCrimesLaw') }}

      b-row
        b-col(md="6")
          b-form-group(:label="$t('label.mainInvestigators')", :label-for="$t('label.mainInvestigators')")
            v-select(
              v-model="data.economicCrimesLawMainInvestigators"
              label="title"
              :multiple="true"
              :options="workersTotal"
              :selectable="worker => !worker.deleted"
              :reduce="worker => worker.value"
              :placeholder="$t('placeholder.mainInvestigators')"
            )

        b-col(md="6")
          b-form-group(:label="$t('label.secondaryInvestigators')", :label-for="$t('label.secondaryInvestigators')")
            v-select(
              v-model="data.economicCrimesLawSecondaryInvestigators"
              label="title"
              :multiple="true"
              :options="workersTotal"
              :selectable="worker => !worker.deleted"
              :reduce="worker => worker.value"
              :placeholder="$t('placeholder.secondaryInvestigators')"
            )

      // Karin Law Investigators
      b-row.mt-2
        b-col(md="12")
          h5 {{ $t('label.karinLaw') }}

      b-row
        b-col(md="6")
          b-form-group(:label="$t('label.mainInvestigators')", :label-for="$t('label.mainInvestigators')")
            v-select(
              v-model="data.karinLawMainInvestigators"
              label="title"
              :multiple="true"
              :options="workersTotal"
              :selectable="worker => !worker.deleted"
              :reduce="worker => worker.value"
              :placeholder="$t('placeholder.mainInvestigators')"
            )

        b-col(md="6")
          b-form-group(:label="$t('label.secondaryInvestigators')", :label-for="$t('label.secondaryInvestigators')")
            v-select(
              v-model="data.karinLawSecondaryInvestigators"
              label="title"
              :multiple="true"
              :options="workersTotal"
              :selectable="worker => !worker.deleted"
              :reduce="worker => worker.value"
              :placeholder="$t('placeholder.secondaryInvestigators')"
            )

      // Ethical Situations Investigators
      b-row.mt-2
        b-col(md="12")
          h5 {{ $t('label.ethicalSituations') }}

      b-row
        b-col(md="6")
          b-form-group(:label="$t('label.mainInvestigators')", :label-for="$t('label.mainInvestigators')")
            v-select(
              v-model="data.ethicalSituationsMainInvestigators"
              label="title"
              :multiple="true"
              :options="workersTotal"
              :selectable="worker => !worker.deleted"
              :reduce="worker => worker.value"
              :placeholder="$t('placeholder.mainInvestigators')"
            )

        b-col(md="6")
          b-form-group(:label="$t('label.secondaryInvestigators')", :label-for="$t('label.secondaryInvestigators')")
            v-select(
              v-model="data.ethicalSituationsSecondaryInvestigators"
              label="title"
              :multiple="true"
              :options="workersTotal"
              :selectable="worker => !worker.deleted"
              :reduce="worker => worker.value"
              :placeholder="$t('placeholder.secondaryInvestigators')"
            )

      // Button
      b-row
        b-col(cols="12", class="text-right")
          b-button(
            variant="success",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}

  // Logs de auditoría
  audit-log-table(
    v-if="isEdit && data",
    :history="data.history || []",
    :field-translations="{ name: $t('label.company') }"
  )

</template>

<script>
import { ref, toRefs, onMounted } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import useCommon from '@/views/organization/useCommon'
import i18n from '@/libs/i18n'
import vSelect from 'vue-select'
import AuditLogTable from '@/components/AuditLogTable.vue'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    AuditLogTable,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const { getWorkersTotalForDropDown, workersTotal } = useCommon()
    const form = ref(null)

    const validateForm = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateForm()
        .then(() => emit('submit', toRefs(props.data)))
        .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    onMounted(() => {
      getWorkersTotalForDropDown()
    })

    return {
      required,
      form,
      validateAndSubmit,
      workersTotal,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style scoped>

</style>
